module.exports = __webpack_public_path__ + "img/join_us3.acc90afd.jpg";